import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NavController, NavParams } from 'ionic-angular';
import { TournamentService } from '../../../../services/tournament.service';

@Component({
  selector: 'result-me-ko-overview',
  templateUrl: 'result-me-ko-overview.html',
})
export class ResultMeKoOverviewPage {  
  @Input() activePlan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  margin: boolean = false;

  constructor(
      private navCtrl: NavController,
      private translate: TranslateService,
      public gs: TournamentService
    ){
    console.log(navCtrl.getViews());
  }

  onOpenEdit(r: number, i: number, j: number){
    this.onEdit.emit({ r: r, i: i, j: j, graph: false});
  }

  onRemoveTeam(){ }

  sort(){
    if(!this.gs.planList[this.activePlan]) return [];

    return this.gs.planList[this.activePlan].teams.sort((a, b) => b.points - a.points);
  }

  getGroupName(i: number){
    let ASCII = 65;
    return String.fromCharCode(ASCII + i);
  }

  getRoundName(r){
    switch (r){
      case 0: return this.translate.instant('FIRST_ROUND');
      case 1: return this.translate.instant('SECOND_ROUND');
      default: return this.translate.instant('ROUND') + (r + 1);
    }
  }
}

export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-me-ko/overview/result-me-ko-overview.ts